import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableHeader, CustomerSummary } from '@/types'

@Component
export default class CostumerListCompnent extends Vue {
  headers: TableHeader[] = [
    {
      text: 'N° D. Ident.',
      value: 'documentIdentity'
    },
    {
      text: 'Cliente',
      value: 'customerName'
    },
    {
      text: 'Monto Gravado',
      value: 'taxedAmount'
    },
    {
      text: 'Monto Exonerado',
      value: 'exoneratedAmount'
    },
    {
      text: 'Monto I.G.V.',
      value: 'taxAmount'
    },
    {
      text: 'Monto Total',
      value: 'totalAmount'
    }
  ]

  @Prop()
  items!: CustomerSummary

  @Prop()
  isLoading!: boolean
}
